<template v-if="$parent.$parent.rerender">
  <div class="row myrow content-mb-42" v-if="isShowComponents()">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_AVAILABLE_IMPORT_POTENTIAL'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>
          <input
            type="checkbox"
            v-model="
              $parent.project.SETTING_TABLE.allData
                .UF_IS_AVAILABLE_IMPORT_POTENTIAL
            "
          />
          Наличие потенциала импортозамещения
        </label>
      </p>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IS_AVAILABLE_IMPORT_POTENTIAL"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "uf_is_available_import_potential",
  computed: {
    ...mapGetters(["directory", "project"])
  },
  methods: {
    isShowComponents() {
      let isShow = false;
      if (this.project.IS_SHOW_TYPE_LOAN == 1) {
        isShow = true;
      } else {
        let t = this.$parent.directory.sp_vid_type_product_list_id.filter(
          c => c.CODE === "pprf_719"
        );

        if (t[0] && t[0].ID == this.project.UF_VID_TYPE_PRODUCT_LIST_ID) {
          isShow = true;
        }
      }

      return isShow;
    }
  }
};
</script>

<style scoped></style>
